import { ValueOf } from '@shared/types/common.ts';

export const ChartKeys = {
  PROVINCE: 'PROVINCE',
  REGION: 'REGION',
  CONTENT: 'CONTENT',
  CHANNELS: 'CHANNELS',
} as const;

export type ChartKey = ValueOf<typeof ChartKeys>;

export const BarColors = {
  primary: '#A855F7',
  blue500: '#3B82F6',
  green500: '#22C55E',
} as const;

export type BarColor = string;
